import {Directive} from '@angular/core';
import {CustomValidationService} from '../services/custom-validation.service';
import {AbstractControl, NG_VALIDATORS} from '@angular/forms';

@Directive({
  selector: '[isAdult]',
  providers: [{provide: NG_VALIDATORS, useExisting: IsAdultDirective, multi: true}]
})
export class IsAdultDirective {

  constructor(private customValidator: CustomValidationService) {
  }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.isAdultValidator()(control);
  }

}
